<wuc-list [lined]="true">
    <wuc-list-icon-item *ngFor="let item of items">
        <wuc-icon-ui wucListItemCustomIcon size="s" [icon]="item.icon"></wuc-icon-ui>
        <wuc-link
            type="quinary"
            [route]="item.route"
            [url]="item.url"
            [attr.e2e]="'insurance-list-' + item.testId"
            target="_self"
        >{{ item.label }}</wuc-link>
    </wuc-list-icon-item>
</wuc-list>
